import apiClient from './client';

export type TipoDocumentoVendita = 'TD01' | 'TD24';

export interface ImpiantoSettings {
  id: string;
  ragione_sociale: string;
  partita_iva: string | null;
  codice_fiscale: string | null;
  sede_via: string | null;
  sede_comune: string | null;
  sede_provincia: string | null;
  sede_cap: string | null;
  numero_aua: string | null;
  capacita_totale_kg: number | null;
  capacita_stoccaggio_kg: number | null;
  capacita_aua_annua_kg: number | null;
  capacita_lavorazione_giornaliera_kg: number | null;
  percentuale_utilizzo_lavorazione: number;
  /** Soglia di scarto del prelievo (#116): 1-50, default 5. */
  soglia_scarto_prelievo_pct: number;
  capacita_giornaliera_effettiva_kg: number | null;
  soglia_ambra_giorni: number;
  soglia_rosso_giorni: number;
  soglia_critico_giorni: number;
  // Dati fatturazione FatturaPA del cedente (V43).
  sede_nazione: string | null;
  regime_fiscale: string | null;
  iban: string | null;
  banca: string | null;
  abi: string | null;
  cab: string | null;
  codice_trasmittente: string | null;
  idpaese_trasmittente: string | null;
  condizioni_pagamento_default: string | null;
  modalita_pagamento_default: string | null;
  iva_trasporto_default: string;        // Gruppo H: aliquota trasporto globale (Decimal→stringa)
  /**
   * V72 — giorni fra emissione e scadenza, su TUTTE le attive (servizio
   * compreso): prima l'XML emetteva DataScadenzaPagamento == data documento,
   * cioè «pagamento a vista» su ogni fattura.
   */
  giorni_scadenza_default: number;
  /** V72 — TipoDocumento delle fatture di VENDITA. TD24 = fattura differita. */
  tipo_documento_vendita: TipoDocumentoVendita;
  rea_ufficio: string | null;
  rea_numero: string | null;
  capitale_sociale: number | null;
  socio_unico: boolean | null;
  stato_liquidazione: string | null;
  pec_cedente: string | null;
  numero_fattura_seed: number | null;
  sezionale_fattura: string | null;     // V62: suffisso del numero ufficiale ('' = legacy)
  // V69 — ricezione fatture passive: dove Ellezeta RICEVE le fatture dei
  // fornitori. Solo prospetto passivo, mai negli XML emessi.
  codice_destinatario_ricezione: string | null;
  pec_ricezione: string | null;
  updated_at: string;
  updated_by: string | null;
}

export async function getImpiantoSettings(): Promise<ImpiantoSettings> {
  const res = await apiClient.get('/api/impianto-settings');
  return res.data;
}

export async function updateImpiantoSettings(body: Partial<Omit<ImpiantoSettings, 'id' | 'updated_at' | 'updated_by'>>): Promise<ImpiantoSettings> {
  const res = await apiClient.patch('/api/impianto-settings', body);
  return res.data;
}
